/**
 * @param {String} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 是否包含汉字
 * @param {*} value
 * @returns
 */
 export function hasSinogram(value) {
  const reg = /[\u4E00-\u9FFF]/;
  return reg.test(value);
}

/**
 * 校验邮箱格式
 * @param {String} email 校验的值
 * @returns {Boolean}
 */
export function isEmail(email) {
  return /^\w+@[a-z0-9]+\.[a-z]{2,4}$/.test(email);
}

/**
 * 校验手机格式
 * @param {String} phone 校验的值
 * @returns {Boolean}
 */
export function isPhone(phone) {
  return /^1\d{10}$/.test(phone);
}
/**
 * 校验是否为英文
 * @param {String} value 校验的值
 * @returns {Boolean}
 */
export function isEnglish(value) {
  return /^[A-Za-z_]+$/.test(value);
}

/**
 * 包含大小写字母和数字的组合，不能使用特殊字符，长度在6-16之间
 * @param {String} pass 校验的值
 * @returns {Boolean}
 */
export function isPassword(pass) {
  return /^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,16}$/g.test(pass);
}

/**
 * 字母和/，且不以/结尾
 * @param {String} router 路由路径
 */
export function isRouter(router) {
  return /^([A-z/])*$/g.test(router);
}

/**
 * 验证是否符合图标文件名的格式，字母和中划线-
 * @param {String} iconPath 图标的文件名
 */
export function isIconPath(iconPath) {
  return /^([A-z])*$/g.test(iconPath);
}

/**
 * 字母和左划线\,且以字母结尾
 * @param {String} componentPath 页面组件的路径
 */
export function isComponentPath(componentPath) {
  return /^([A-z])*[A-z]$/g.test(componentPath);
}

/**
 * 校验输入的登录帐号格式是否正确
 * @param {String} loginName 登录帐号
 */
export function isLoginName(loginName) {
  return /^\w*$/g.test(loginName);
}

/**
 * 检查是否是图片
 * @param {*} str
 */
export function isImage(str) {
  const reg = /\.(png|jpg|gif|jpeg|webp)$/;
  return reg.test(str.toLowerCase());
}

/**
 * 检查是否是视频
 */
export function isVideo(str) {
  // const reg = /\.(mp4|rmvb|flv|mpeg|avi|dat|mov)$/;
  const reg = /\.mp4$/;
  return reg.test(str.toLowerCase());
}
/**
 * 是否是PDF文件
 * @param {*} str
 * @returns
 */
export function isPdf(str) {
  const reg = /\.(pdf)$/;
  return reg.test(str.toLowerCase());
}

/**
 * 是否是正整数
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function isInteger(value) {
  const reg = /^[1-9]\d*$/;
  return reg.test(value);
}

/**
 * 是否是自然数
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function isNaturalNumber(value) {
  const reg = /^[0-9]\d*$/;
  return reg.test(value);
}

/**
 * 是否是有上限的自然数（0~9999999）
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function isNaturalLimit(value) {
  const reg = /^\+?[0-9]{1}[0-9]{0,6}\d{0,0}$/;
  return reg.test(value);
}

/**
 * 是否是有上限的正整数 1~ 99999999
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function isIntegerLimit(value) {
  const reg = /^\+?[1-9]{1}[0-9]{0,7}\d{0,0}$/;
  return reg.test(value);
}

/**
 * 是否已http、https开头
 * @param {*} value
 * @returns
 */
export function isHttp(value) {
  const reg = /(http|https):\/\/([\w.]+\/?)\S*/;
  return reg.test(value);
}

/**
 * 数字+大写+小写+特殊字符 任意三类的密码组合
 */
 export function passwordRules(value) {
  if(hasSinogram(value)){
    // 不能包含中文
    return false;
  }
  var reg = new RegExp(/^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/);
  return reg.test(value);
}

export function isFunction(value) {
  return typeof value === 'function'
}

/**
 * 判断当前页面是否是运行在移动端
 * @return {boolean}
 */
export function isInMobile() {
   return /Mobi|Android|iPhone/i.test(navigator.userAgent)
}

export default {
  isInteger,
  isHttp,
  isNaturalLimit,
  isIntegerLimit,
  isNaturalNumber,
  passwordRules,
  isFunction
};

